import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-bootstrap/Carousel";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import useArticlesSlider from "../hooks/useArticlesSlider";
import { formatearFecha } from "../helpers/formatearFecha";
import { isVideo } from "../helpers/isVideo";

const SliderHome = () => {
  const { articlesSlider } = useArticlesSlider();

  return (
    <>
      <Carousel pause fade id="sliderhome__home">
        {articlesSlider.map(
          (item) =>
            item.state === true &&
            item.deleted === false && (
              <Carousel.Item
                key={item._id}
                className={item?.align !== "" ? `carousel ${item.align}` : "carousel align-center"}
                interval={7000}
              >
                <picture>
                  <source
                    media="(orientation: portrait) and (max-width: 1199px)"
                    srcSet={item.image_mobile ? item.image_mobile[0]?.url : item.image_mobile}
                    alt={item.image_mobile ? item.image_mobile[0]?.alt : item?.title}
                    title={item?.title}
                  />
                  <source
                    media="(orientation: landscape) and (max-width: 1199px)"
                    srcSet={item.image_tablet ? item.image_tablet[0]?.url : item.image_tablet}
                    alt={item.image_tablet ? item.image_tablet[0]?.alt : item?.title}
                    title={item?.title}
                  />
                  {isVideo(
                    item?.image_desktop ? item?.image_desktop[0]?.url : ""
                  ) ? (
                    <video
                      src={
                        item?.image_desktop ? item?.image_desktop[0]?.url : ""
                      }
                      className="img-responsive"
                      muted
                      controls
                    />
                  ) : (
                    <img
                      className="img-responsive"
                      src={item.image_desktop ? item.image_desktop[0]?.url : item.image_desktop}
                      alt={item.image_desktop ? item.image_desktop[0]?.alt : item?.title}
                      title={item?.title}
                      loading="lazy"
                    />
                  )}
                </picture>
                <div
                  className={
                    item?.align === "align-left"
                      ? `container contenedor-left`
                      : item?.align === "align-right"
                        ? "container contenedor-right"
                        : "container contenedor-center"
                  }
                >
                  <Carousel.Caption>
                    <div className="info-slider-home fadeInRight">
                      <p className="stiker-card-slider">{item.section}</p>
                      <h1 className="title-card-slider">{item.title}</h1>
                      {item.includeDate && (
                        <p className="sliderhome__carousel-fecha">
                          {formatearFecha(item.creation_date)}
                        </p>
                      )}
                      <p className="description_desktop content_p">{item.content}</p>
                      <p className="description_mobile content_p">{item.content_mobile}</p>
                      {item?.link && (
                        <button className="settings_button-pleno bg-p-primary_2 posicion-boton">
                          <a href={item?.link} title="ver noticia">
                            <ArrowForwardOutlinedIcon />
                          </a>
                        </button>
                      )}
                    </div>
                  </Carousel.Caption>
                </div>
              </Carousel.Item>
            )
        )}
      </Carousel>
    </>
  );
};
export default SliderHome;
